module.exports = {"TXTWCL_Place_Bet":{"id":"TXTWCL_Place_Bet","defaultMessage":"Placer une mise","track":"Place Bet"}}